import React, {useCallback, useEffect, useState} from 'react'
import {useIntl} from 'react-intl'
import {useNavigate, useSearchParams} from 'react-router-dom'
import {toast} from 'react-toastify'
import {LoadingPage} from '../../../../../../../_gori/helpers/components/LoadingPage'
import {OrderType} from '../../../../../orders/core/_const'
import SettingsService from '../../../../core/_requests'
import {isEmpty} from 'lodash'
import {ROUTES} from '../../../../../../../_gori/constants'
import {StorageHelpers} from '../../../../../../../_gori/helpers'

const VerifyTikTok: React.FC = () => {
  const intl = useIntl()
  const navigate = useNavigate()
  const [queryParams] = useSearchParams()
  const app_key = queryParams.get('app_key')
  const code = queryParams.get('code')
  const locale = queryParams.get('locale')
  const shop_region = queryParams.get('shop_region')
  const [isLoading, setIsLoading] = useState<boolean>(false)

  const connectTikTok = useCallback(async () => {
    setIsLoading(true)
    await SettingsService.connect({
      app_key: app_key,
      code: code,
      locale: locale,
      shop_region: shop_region,
      store_type: OrderType.TIKTOK,
    })
      .then(async () => {
        StorageHelpers.setItemLocalStorage('cardstore', {hidden: true})
        window.dispatchEvent(new Event('storage'))
        toast.success(intl.formatMessage({id: 'CONNECTION_SUCCESSFUL'}))
      })
      .catch((error) => {
        let message = error?.response?.data?.error?.message ?? ''
        toast.error(isEmpty(message) ? intl.formatMessage({id: 'CONNECTION_FAILED'}) : message)
      })
      .finally(() => {
        setIsLoading(false)
        navigate(ROUTES.SETTINGS.CONNECTIONS.TIKTOK)
      })
  }, [app_key, code, locale, shop_region, intl, navigate])

  useEffect(() => {
    connectTikTok()
  }, [connectTikTok])

  return isLoading ? <LoadingPage className='start-0' /> : <></>
}

export {VerifyTikTok}
